import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/categories';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3 whitespace-nowrap">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Frequently Asked Questions About <span className="text-primary-500">Sugargoo Spreadsheet</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="font-heading font-semibold text-sm md:text-base text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === idx ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                  <i className={`ri-${openIndex === idx ? 'subtract' : 'add'}-line text-sm`}></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4">
                  <div className="pt-1 border-t border-background-200/70">
                    <p className="text-sm text-foreground-600 leading-relaxed pt-3">
                      {item.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/sugargoo-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            Read the Complete Sugargoo Spreadsheet Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}